import { ThemeColor } from '@/enums'
import { SearchIcon } from '@/icons'
import { fromEventTarget, parseChildrenArray } from '@/utils'
import { ReactNode, useState } from 'react'
import { InputWithAddon } from '../../atoms'
import { SelectOptionValueType, OptionNode } from './OptionNode'
import { Container, OptionsContainer } from './styles'

export interface ListSelectProps {
  value?: SelectOptionValueType
  onChange: (value: SelectOptionValueType) => void
  searchPlaceholder?: string
  children: ReactNode
  disabled?: boolean
}

export const ListSelect = ({
  value,
  onChange,
  searchPlaceholder,
  children,
  disabled,
}: ListSelectProps) => {
  const options = parseChildrenArray(children)
  const [searchedValue, setSearchedValue] = useState('')

  const filteredOptions = options.filter(({ children: text }) =>
    String(text).toLowerCase().includes(searchedValue.toLowerCase()),
  )

  return (
    <Container>
      <InputWithAddon
        addonBefore={() => <SearchIcon color={ThemeColor.b50} />}
        onChange={fromEventTarget(setSearchedValue)}
        placeholder={searchPlaceholder}
        rounded
        value={searchedValue}
      />
      <OptionsContainer>
        {filteredOptions.map(
          ({
            key,
            value: optionValue,
            children: text,
            disabled: optionDisabled,
            icon,
          }) => (
            <OptionNode
              key={key}
              disabled={disabled || optionDisabled}
              icon={icon}
              onClick={onChange}
              selected={value === optionValue}
              text={String(text)}
              value={optionValue}
            />
          ),
        )}
      </OptionsContainer>
    </Container>
  )
}
